import EnquiryChat from "@/views/probaworkflows_base/entity/enquiry_chat/EnquiryChat.vue";
import LeadQuestionnaire from "../lead_questionnaire/LeadQuestionnaire.vue";
import EntityInvoiceOverview from "../entity_applications/entity_invoice_overview/EntityInvoiceOverview.vue";
import ProofOfPayments from "../proof_of_payments/ProofOfPayments.vue";
import EntityReviewQuote from "../entity_applications/entity_review_quote/EntityReviewQuote.vue";
import UploadMeetingMinutes from "@/views/probaworkflows_base/management/customer_management/upload_meeting_minutes/UploadMeetingMinutes.vue";
import EntityVerificationResults from "@/views/probaworkflows_base/entity/entity_applications/entity_verification_results/EntityVerificationResults.vue";

export default{
    name: 'lead_management',

  components: {
    EnquiryChat,
    LeadQuestionnaire,
    EntityInvoiceOverview,
    EntityReviewQuote,
    ProofOfPayments,
    UploadMeetingMinutes,
    EntityVerificationResults
  },
  data: () => ({
    activeTab: 'enquiry',
    selectedDropdown: 'enquiry',
    lead_name: '',
    lead_id: null
  }),
  mounted() {
    this.lead_name = sessionStorage.getItem('lead_name');
    this.lead_id = sessionStorage.getItem('lead_id'); // Get lead_id from session storage
    
    // Parse lead_id if it's a string
    if (this.lead_id) {
      this.lead_id = parseInt(this.lead_id, 10); // explicitly set base 10
    }
    
    const saved_tab = localStorage.getItem('active_tab');
    if (saved_tab) {
      this.activeTab = saved_tab;
    }else{
      this.activeTab = 'enquiry';
    }
  },

  methods: {
    selectTab(tab) {
      this.activeTab = tab;
      localStorage.setItem('active_tab', this.activeTab);
      this.selectedDropdown = tab; // Auto-expand the corresponding dropdown
    },
    toggleDropdown(dropdown) {
      if (this.selectedDropdown === dropdown) {
        this.selectedDropdown = null;
      } else {
        this.selectedDropdown = dropdown;
      }
    },
    set_active_tab(tab) {
      this.activeTab = tab;
      localStorage.setItem('active_tab', this.activeTab);
    },
    get_tab_icon() {
    }
  }

  
}